import { NumberFormatException3bgsm2s9o4t55 as NumberFormatException } from '../exceptions.mjs';
import {
  checkRadix3se2t8fmlp8f6 as checkRadix,
  digitOf3au6ftls3g9n1 as digitOf,
} from './numberConversions.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../Unit.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../js/charSequenceJs.mjs';
import {
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  Char__compareTo_impl_ypi4mb1yxpplfe5vmm as Char__compareTo_impl_ypi4mb,
} from '../Char.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  dividelr0uqtdj497z as divide,
  multiply2k9eolhnz1bjv as multiply,
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  negate13xrbakfwasjy as negate,
} from '../js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  toByte4i43936u611k as toByte,
  toShort36kaw0zjdq3ex as toShort,
} from '../js/numberConversion.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function toLongOrNull(_this__u8e3s4) {
  return toLongOrNull_0(_this__u8e3s4, 10);
}
function toByteOrNull(_this__u8e3s4) {
  return toByteOrNull_0(_this__u8e3s4, 10);
}
function toShortOrNull(_this__u8e3s4) {
  return toShortOrNull_0(_this__u8e3s4, 10);
}
function toIntOrNull(_this__u8e3s4) {
  return toIntOrNull_0(_this__u8e3s4, 10);
}
function numberFormatError(input) {
  throw NumberFormatException().qe("Invalid number format: '" + input + "'");
}
function toLongOrNull_0(_this__u8e3s4, radix) {
  checkRadix(radix);
  var length = _this__u8e3s4.length;
  if (length === 0)
    return null;
  var start;
  var isNegative;
  var limit;
  var firstChar = charCodeAt(_this__u8e3s4, 0);
  if (Char__compareTo_impl_ypi4mb(firstChar, _Char___init__impl__6a9atx(48)) < 0) {
    if (length === 1)
      return null;
    start = 1;
    if (firstChar === _Char___init__impl__6a9atx(45)) {
      isNegative = true;
      limit = -9223372036854775808n;
    } else if (firstChar === _Char___init__impl__6a9atx(43)) {
      isNegative = false;
      limit = -9223372036854775807n;
    } else
      return null;
  } else {
    start = 0;
    isNegative = false;
    limit = -9223372036854775807n;
  }
  // Inline function 'kotlin.Long.div' call
  var this_0 = -9223372036854775807n;
  var limitForMaxRadix = divide(this_0, fromInt(36));
  var limitBeforeMul = limitForMaxRadix;
  var result = 0n;
  var inductionVariable = start;
  if (inductionVariable < length)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var digit = digitOf(charCodeAt(_this__u8e3s4, i), radix);
      if (digit < 0)
        return null;
      if (result < limitBeforeMul) {
        if (limitBeforeMul === limitForMaxRadix) {
          // Inline function 'kotlin.Long.div' call
          var this_1 = limit;
          limitBeforeMul = divide(this_1, fromInt(radix));
          if (result < limitBeforeMul) {
            return null;
          }
        } else {
          return null;
        }
      }
      // Inline function 'kotlin.Long.times' call
      var this_2 = result;
      result = multiply(this_2, fromInt(radix));
      var tmp = result;
      // Inline function 'kotlin.Long.plus' call
      var this_3 = limit;
      if (tmp < add(this_3, fromInt(digit)))
        return null;
      // Inline function 'kotlin.Long.minus' call
      var this_4 = result;
      result = subtract(this_4, fromInt(digit));
    }
     while (inductionVariable < length);
  return isNegative ? result : negate(result);
}
function toByteOrNull_0(_this__u8e3s4, radix) {
  var tmp0_elvis_lhs = toIntOrNull_0(_this__u8e3s4, radix);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var int = tmp;
  if (int < -128 || int > 127)
    return null;
  return toByte(int);
}
function toShortOrNull_0(_this__u8e3s4, radix) {
  var tmp0_elvis_lhs = toIntOrNull_0(_this__u8e3s4, radix);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var int = tmp;
  if (int < -32768 || int > 32767)
    return null;
  return toShort(int);
}
function toIntOrNull_0(_this__u8e3s4, radix) {
  checkRadix(radix);
  var length = _this__u8e3s4.length;
  if (length === 0)
    return null;
  var start;
  var isNegative;
  var limit;
  var firstChar = charCodeAt(_this__u8e3s4, 0);
  if (Char__compareTo_impl_ypi4mb(firstChar, _Char___init__impl__6a9atx(48)) < 0) {
    if (length === 1)
      return null;
    start = 1;
    if (firstChar === _Char___init__impl__6a9atx(45)) {
      isNegative = true;
      limit = -2147483648;
    } else if (firstChar === _Char___init__impl__6a9atx(43)) {
      isNegative = false;
      limit = -2147483647;
    } else
      return null;
  } else {
    start = 0;
    isNegative = false;
    limit = -2147483647;
  }
  var limitForMaxRadix = -59652323;
  var limitBeforeMul = limitForMaxRadix;
  var result = 0;
  var inductionVariable = start;
  if (inductionVariable < length)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var digit = digitOf(charCodeAt(_this__u8e3s4, i), radix);
      if (digit < 0)
        return null;
      if (result < limitBeforeMul) {
        if (limitBeforeMul === limitForMaxRadix) {
          limitBeforeMul = limit / radix | 0;
          if (result < limitBeforeMul) {
            return null;
          }
        } else {
          return null;
        }
      }
      result = imul(result, radix);
      if (result < (limit + digit | 0))
        return null;
      result = result - digit | 0;
    }
     while (inductionVariable < length);
  return isNegative ? result : -result | 0;
}
//region block: exports
export {
  numberFormatError as numberFormatErrorhrxz6mwzt3x8,
  toByteOrNull as toByteOrNull1d9df6kfxiznx,
  toIntOrNull as toIntOrNull3w2d066r9pvwm,
  toLongOrNull as toLongOrNullutqivezb0wx1,
  toShortOrNull as toShortOrNullaofc97cf0fby,
};
//endregion

//# sourceMappingURL=StringNumberConversions.mjs.map
